import { useState } from 'react';
import { LangSwitcher } from './LangSwitcher.jsx';
import { ThemeSwitcher } from './ThemeSwitcher.jsx';
import { UserBar } from './UserBar.jsx';
import { T } from './T.jsx';

const NAV_LINKS = [
  { href: '#features',    k: 'ml_nav_features', label: 'Features' },
  { href: '#roles',       k: 'ml_nav_roles',    label: 'Roles' },
  { href: '#ai-assistant', k: 'ml_nav_ai',      label: 'AI' },
  { href: '#workflow',    k: 'ml_nav_workflow', label: 'How It Works' },
  { href: '#themes-demo', k: 'ml_nav_themes',   label: 'Themes' },
  { href: '#testimonials', k: 'ml_nav_reviews', label: 'Reviews' },
  { href: '#examples',    k: 'ml_nav_examples', label: 'Examples' },
];

export function Navbar({
  scrolled,
  activeId,
  theme,
  accentGradient,
  onChooseTheme,
  lang,
  displayMode,
  onChooseLang,
  onChooseMode,
  onOpenDisclaimer,
  disclaimerVisible,
  user,
  authLoading,
  onSignIn,
  onSignOut,
  onNavigate,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  // Only one dropdown may be open at a time — opening either closes the other.
  const [openDropdown, setOpenDropdown] = useState(null);

  const go = (href) => (e) => {
    e.preventDefault();
    setMenuOpen(false);
    onNavigate(href);
  };

  return (
    <nav id="navbar" className={scrolled ? 'scrolled' : ''}>
      <a href="#hero" className="nav-brand" onClick={go('#hero')}>
        <div className="nav-logo">
          <span />
          <span />
          <span />
        </div>
        <span className="nav-title">MyLecture</span>
      </a>

      <ul className={`nav-links${menuOpen ? ' open' : ''}`}>
        {NAV_LINKS.map((link) => (
          <li key={link.href}>
            <a
              href={link.href}
              className={activeId && `#${activeId}` === link.href ? 'active' : ''}
              onClick={go(link.href)}
            >
              <T k={link.k}>{link.label}</T>
            </a>
          </li>
        ))}
      </ul>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <LangSwitcher
          lang={lang}
          mode={displayMode}
          onChooseLang={onChooseLang}
          onChooseMode={onChooseMode}
          onOpenDisclaimer={onOpenDisclaimer}
          open={openDropdown === 'lang'}
          onToggle={() => setOpenDropdown((d) => (d === 'lang' ? null : 'lang'))}
          onClose={() => setOpenDropdown((d) => (d === 'lang' ? null : d))}
        />

        <ThemeSwitcher
          theme={theme}
          accentGradient={accentGradient}
          onChoose={onChooseTheme}
          open={openDropdown === 'theme'}
          onToggle={() => setOpenDropdown((d) => (d === 'theme' ? null : 'theme'))}
          onClose={() => setOpenDropdown((d) => (d === 'theme' ? null : d))}
        />

        <UserBar user={user} loading={authLoading} onSignIn={onSignIn} onSignOut={onSignOut} />

        <button
          className={`i18n-disclaimer-btn${disclaimerVisible ? ' visible' : ''}`}
          aria-label="Translation disclaimer"
          title="Translation disclaimer"
          onClick={onOpenDisclaimer}
        >
          <span className="i18n-icon">&#9432;</span>
          <span>AI Translation</span>
        </button>

        <button
          className="nav-hamburger"
          aria-label="Menu"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </nav>
  );
}
